import { STATUSES } from "@/lib/constants";
import { cn } from "@/lib/utils";

export default function StatusBadge({ status, className }) {
  const s = STATUSES[status] || STATUSES.nouveau;
  return (
    <span
      data-testid={`status-badge-${status}`}
      style={{ backgroundColor: s.bg, color: s.text }}
      className={cn("inline-flex items-center rounded-full px-3 py-1 text-xs font-bold tracking-wide", className)}
    >
      {s.label}
    </span>
  );
}
